var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsConnecting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5520.000000, -3526.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5521.000000, 3526.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.93,0.472 L0.93,39.472 L44.139,39.333",
    id: "Path_10143",
    stroke: "#006DC9",
    strokeWidth: 2,
    strokeDasharray: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsConnecting);
export default __webpack_public_path__ + "static/media/dots-connecting.3d443d013ec7a515d9ab6cd3f8586aa6.svg";
export { ForwardRef as ReactComponent };